import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

/**
 * 決済失敗コールバック受け口
 *
 * GMO / NP 後払いからのコールバックで /failed?inquiryId=xxx に遷移してくる。
 * inquiryId は本物の inquiry_id（doctor 側実装と同仕様）。
 * 後払い (NP) の与信NG時は postpaidAuth=false が付与される（PaymentFailed で文言切替に使用）。
 *
 * NP 後払いは外部ドメインを経由するため sessionStorage が消える可能性があり、
 * URL の inquiryId に依拠する形に統一している。
 */
const PaymentFailure: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const inquiryId = searchParams.get('inquiryId');
  const isPostpaidAuthError = searchParams.get('postpaidAuth') === 'false';
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (inquiryId) {
      const suffix = isPostpaidAuthError ? '?postpaidAuth=false' : '';
      navigate(`/inquiries/${inquiryId}/payment-failed${suffix}`, { replace: true });
    } else {
      setHasError(true);
    }
  }, [inquiryId, isPostpaidAuthError, navigate]);

  if (hasError) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        gap: '16px'
      }}>
        <p>エラーが発生しました</p>
        <p style={{ fontSize: '14px', color: '#666' }}>
          決済情報が見つかりませんでした
        </p>
      </div>
    );
  }

  return null;
};

export default PaymentFailure;
